export enum SocureProcessFlow {
  UploadOnly = 1,
  UploadAndVerification = 3
}
